import { DataFetcher } from "@/components/display";
import { Dialog, DialogProps, ModalHeader, ModalValueExtractor } from "@/components/modal";
import { GetCajaActualAperturaActualMovimientoQuery } from "@/features/cajas/caja-actual/api/get-caja-actual-apertura-actual-movimiento";
import ViewCajaActualMovimiento from "@/features/cajas/caja-actual/components/view-caja-actual-movimiento";
import { formatDate } from "@/shared/formats";

export default function ViewCajaActualMovimientoModal({
    ...props
}: DialogProps) {
    return <Dialog size="md" {...props}>
        <ModalValueExtractor>
            {movimientoId => <GetCajaActualAperturaActualMovimientoQuery id={movimientoId}>
                {query => <DataFetcher query={query} flex={1}>
                    {movimiento => <>
                        <ModalHeader>Movimiento de Caja - {formatDate(movimiento.fecha, true)}</ModalHeader>
                        <ViewCajaActualMovimiento
                            cajaMovimiento={movimiento}
                            padding={3}
                            flex={1}
                        />
                    </>}
                </DataFetcher>}
            </GetCajaActualAperturaActualMovimientoQuery>}
        </ModalValueExtractor>
    </Dialog>
}
